module.exports = __webpack_public_path__ + "static/media/Triangle Area.04fd569e.kra";